/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Toast_Reingest_Bulk_LoadingInputs */

const es_settings_files_toast_reingest_bulk_loading = /** @type {(inputs: Settings_Files_Toast_Reingest_Bulk_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Re-ingestando ${i?.count} archivo(s)…`)
};

const en_settings_files_toast_reingest_bulk_loading = /** @type {(inputs: Settings_Files_Toast_Reingest_Bulk_LoadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Re-ingesting ${i?.count} file(s)…`)
};

/**
* | output |
* | --- |
* | "Re-ingesting {count} file(s)…" |
*
* @param {Settings_Files_Toast_Reingest_Bulk_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_bulk_loading = /** @type {((inputs: Settings_Files_Toast_Reingest_Bulk_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_Bulk_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_bulk_loading(inputs)
	return en_settings_files_toast_reingest_bulk_loading(inputs)
});
export { settings_files_toast_reingest_bulk_loading as "settings.files.toast.reingest_bulk_loading" }